import { Button } from '@revdotcom/vaporwave';

import styles from '../../styles';
import { type FlowProps } from '../../FlowProps';
import { type LandingPageProps } from '../../codegen/LandingPageProps';

/**
 * Renders a simple page with a redirect button
 * @param {object} props parameters
 * @param {string} props.landingRedirect redirect url
 * @returns {Element} page content
 */
const LandingPage = (props: FlowProps<LandingPageProps>) => {
    if (!props.landingRedirect) return <></>;

    return (
        <Button sx={styles.landingButton} href={props.landingRedirect}>
            Proceed
        </Button>
    );
};

export default LandingPage;
